import React from 'react';
import { Check, ChevronRight } from '@sparkpost/matchbox-icons';
import { UnstyledLink } from 'src/components/matchbox';
import styles from './SubaccountOption.module.scss';

function SubaccountOption(props) {
  const handleClick = () => {
    const { onChange, selected, value } = props;

    if (!selected) {
      onChange(value);
    }
  };

  const { label, nested, onOpen, selected } = props;

  if (nested) {
    return (
      <UnstyledLink className={styles.Option} onClick={onOpen}>
        {label} <ChevronRight />
      </UnstyledLink>
    );
  }

  return (
    <UnstyledLink className={styles.Option} onClick={handleClick}>
      {label} {selected && <Check className={styles.Check} />}
    </UnstyledLink>
  );
}

export default SubaccountOption;
